import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, FormArray, Validators } from "@angular/forms";
import { NgbDate, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { map } from "leaflet";
import { EventService } from "src/app/core/services/event.service";
import { ApiService } from "src/app/shared/services/api.service";
import Swal from "sweetalert2";
import * as moment from "moment";
import { Router } from "@angular/router";
import { Lightbox, LightboxConfig } from "ngx-lightbox";
import { environment } from "src/environments/environment";
import { RouterLink } from "@angular/router";
import { SafeUrl } from "@angular/platform-browser";
import { CurrencyPipe } from "@angular/common";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { saveAs } from "file-saver";
@Component({
  selector: "app-branch-manager",
  templateUrl: "./branch-manager.component.html",
  styleUrls: ["./branch-manager.component.scss"],
})
export class BranchManagerComponent implements OnInit {
  constructor(
    private router: Router,
    private http: HttpClient,
    private apiService: ApiService,
    private modalService: NgbModal,
    public formBuilder: FormBuilder,
    private eventService: EventService,
    private translateService: TranslateService,
    private fb: FormBuilder
  ) {}
  name: "";
  terminalAddress: "";
  terminalBankAcc: "";
  terminalBankName: "";
  terminalBankAccountName: "";
  listBankname = [
    {
      name: "MB Bank",
      id: "970422",
    },
  ];
  id = JSON.parse(localStorage.getItem("currentUser")).id;
  userToken = JSON.parse(localStorage.getItem("currentUser")).user_token;
  full_name = JSON.parse(localStorage.getItem("currentUser")).full_name;
  searchTerm;
  listData = [];
  listData2 = [];
  listData3 = [];
  pageSize = 10;
  pageIndex = 1;
  totalCount = 0;
  // tableName = 'workspaces'
  tableName1 = "agency";
  // tableName2 = 'devices/active'
  // tableName3 = 'bankaccounts/active'
  tableName4 = "workspaces/device-and-bankaccount";
  role = JSON.parse(localStorage.getItem("currentUser"))["role"];
  submitted: boolean;
  formData: FormGroup;
  formData2: FormGroup;
  listType = [
    { value: "", label: "Tất cả" },
    { value: 0, label: "Chưa cấp loa" },
    { value: 1, label: "Đã cấp loa" },
  ];
  hoveredDate: NgbDate;
  fromNGDate: NgbDate;
  toNGDate: NgbDate;
  breadCrumbItems;
  hidden: boolean = true;

  months: number[] = Array.from({ length: 12 }, (_, i) => i + 1); // [1, 2, ..., 12]
  years: number[] = [];

  get form() {
    return this.formData.controls;
  }

  ngOnInit() {
    this.breadCrumbItems = [
      { label: "PAGE.HOME" },
      { label: "PAGE.REPORT.IncidentType", active: true },
    ];
    this.fetchData();
    this.fetchDataBranch();
    this.generateYears();
  }
  
  generateYears() {
    const currentYear = new Date().getFullYear();
    const startYear = 2024;
    this.years = Array.from(
      { length: currentYear - startYear + 1 },
      (_, i) => startYear + i
    );
  }
  exportExelBranch() {
    this.eventService.setLoading(true);
    const headers = new HttpHeaders({
      "Content-Type":
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      Accept:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = `dashboard/device-branch?model=export&agency_id=${this.filter.agency_id}&is_provided=${this.filter.is_provided}`;

    this.http.get(url, { headers, responseType: "blob" }).subscribe({
      next: (res: Blob) => {
        this.eventService.setLoading(false);
        const now = new Date();
        const formattedDate = `${now.getFullYear()}-${String(
          now.getMonth() + 1
        ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;

        const fileName = `Bao_cao_chi_nhanh_${formattedDate}.xlsx`;

        saveAs(res, fileName);
          this.modalService.dismissAll();

      },
      error: (e) => {
        if (e) {
          this.apiService.showToastMobile(
            "error",
            this.translateService.instant(e)
          );
        } else {
          this.apiService.showToastMobile(
            "error",
            this.translateService.instant("Xuất file lỗi")
          );
        }
        this.eventService.setLoading(false);
      },
    });
  }

  exportExelQuantity() {
    this.eventService.setLoading(true);
    const headers = new HttpHeaders({
      "Content-Type":
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      Accept:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = `reports/branch-device?model=export&agency_id=${this.filter.agency_id}&is_provided=${this.filter.is_provided}`;

    this.http.get(url, { headers, responseType: "blob" }).subscribe({
      next: (res: Blob) => {
        this.eventService.setLoading(false);
        const now = new Date();
        const formattedDate = `${now.getFullYear()}-${String(
          now.getMonth() + 1
        ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;

        const fileName = `Bao_cao_so_loa_chi_nhanh_${formattedDate}.xlsx`;

        saveAs(res, fileName);
          this.modalService.dismissAll();

      },
      error: (e) => {
        if (e) {
          this.apiService.showToastMobile(
            "error",
            this.translateService.instant(e)
          );
        } else {
          this.apiService.showToastMobile(
            "error",
            this.translateService.instant("Xuất file lỗi")
          );
        }
        this.eventService.setLoading(false);
      },
    });
  }
  binNumber = "970422";
  accountNumber = "";
  bank_accountName = "";
  onInputBlur() {
    this.eventService.setLoading(true);

    const data = {
      partner_id: this.id,
      accountNumber: this.accountNumber,
      token: this.userToken,
    };

    this.http
      .post("https://paydee.tomotek.vn/prod/bank/account-info", data)
      .subscribe(
        (response: any) => {
          this.eventService.setLoading(false);
          if (
            response.ResponseData.errorCode === "200" &&
            !response.ResponseData.data
          ) {
            this.apiService.showToastMobile(
              "error",
              this.translateService.instant("Không tìm thấy tài khoản")
            );
          } else if (response.ResponseData.data) {
            this.apiService.showToastMobile(
              this.translateService.instant("success"),
              this.translateService.instant("Tìm kiếm thành công")
            );
            this.bank_accountName = response.ResponseData.data.accountName;
            this.searching = true;
          } else {
            this.apiService.showToastMobile(
              "error",
              this.translateService.instant(
                "Có lỗi xảy ra khi tìm kiếm tài khoản"
              )
            );
          }
        },
        (error) => {
          this.eventService.setLoading(false);
          console.error("Error occurred:", error);
          this.apiService.showToastMobile(
            "error",
            this.translateService.instant("Lỗi kết nối. Vui lòng thử lại sau.")
          );
        }
      );
  }
  onChangePage(e) {
    this.pageIndex = e;
    this.fetchData();
  }

  clearDate() {
    this.selected = "";
    this.filter.startdate = 0;
    this.filter.enddate = 0;
  }

  filter = {
    type_id: -1,
    agency_id: "",
    is_provided: "",
    status: -1,
    startdate: -1,
    enddate: -1,
  };
  searching = false;

  params = "";
  submitFilter() {
    this.params = "";
    Object.keys(this.filter).forEach((key) => {
      console.log(key + "-" + this.filter[key]);
      if (this.filter[key] || this.filter[key] >= 0) {
        this.params += `&${key}=${this.filter[key]}`;
      }
    });

    if (this.params) {
      this.pageIndex = 1;
      this.searching = true;
      this.fetchData();
    }
  }
  selected: any;

  clearFilter() {
    this.selected = "";
    this.params = "";
    this.filter.agency_id = "";
    this.filter.type_id = -1;
    this.filter.status = -1;
    this.filter.is_provided = "";
    this.filter.startdate = 0;
    this.filter.enddate = 0;
    this.pageIndex = 1;
    // this.searching = false
    this.fetchData();
  }

  fetchData() {
    // params = '&order=updated_at&direction=desc'
    this.eventService.setLoading(true);
    this.apiService
      .getList(
        this.tableName1 +
          `?page=${this.pageIndex}&limit=${this.pageSize}${this.params}`
      )
      .subscribe({
        next: (res) => {
          // this.listData = res.workspaces
          this.listData = res["metadata"]["agency"]
            ? res["metadata"]["agency"]
            : [];
          this.totalCount = res.metadata.pagination.totalCount
            ? res.metadata.pagination.totalCount
            : "";
          this.eventService.setLoading(false);
        },
      });
  }
  listBranch;

  fetchDataBranch() {
    this.apiService.getList(this.tableName1).subscribe({
      next: (res) => {
        this.listBranch = res["metadata"]["agency"]
          ? res["metadata"]["agency"]
          : [];
      },
    });
  }
  list_serial_number = [];

  // fetchData2(params = '') {
  //   params = '&order=updated_at&direction=desc'
  //   this.eventService.setLoading(true)
  //   this.apiService.getList(this.tableName2 +
  //     `?page=${this.pageIndex}&limit=${this.pageSize}${params}`
  //   ).subscribe({
  //     next: (res) => {
  //       // this.listData = res.workspaces
  //       this.listData2 = res['devices'] ? res['devices'] : [];

  //       this.listData.forEach((item) => {
  //         if (item['id']) {
  //           this.list_serial_number.push(item['id']);
  //         }
  //       })
  //       console.log(this.list_serial_number)
  //       this.totalCount = res.length
  //       this.eventService.setLoading(false)
  //     }
  //   })
  // }

  list_id_account = [];

  // fetchData3(params = '') {
  //   params = '&order=updated_at&direction=desc'
  //   this.eventService.setLoading(true)
  //   this.apiService.getList(this.tableName3 + `?page=${this.pageIndex}&limit=${this.pageSize}${params}`
  //   ).subscribe({
  //     next: (res) => {
  //       this.listData3 = res['bankaccounts'] ? res['bankaccounts'] : [];
  //       console.log(this.listData3)

  //       this.listData3.forEach((item) => {
  //         if (item['id']) {
  //           this.list_id_account.push(item['id']);
  //         }

  //       }
  //       )

  //       // console.log(this.list_id_account)
  //       this.totalCount = res.length
  //       // console.log(this.totalCount)
  //       // // this.totalCount = res.meta.total
  //       this.eventService.setLoading(false)
  //     }
  //   })
  // }
  @Input() fromDate: Date;
  @Input() toDate: Date;
  @Output() dateRangeSelected: EventEmitter<{}> = new EventEmitter();

  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromNGDate = date;
      this.fromDate = new Date(date.year, date.month - 1, date.day);
      this.selected = "";
      this.filter.startdate = 0;
      this.filter.enddate = 0;
    } else if (
      this.fromDate &&
      !this.toDate &&
      (date.after(this.fromNGDate) || date.equals(this.fromNGDate))
    ) {
      this.toNGDate = date;
      this.toDate = new Date(date.year, date.month - 1, date.day);
      this.hidden = true;
      // this.selected = this.fromDate.toLocaleDateString() + '-' + this.toDate.toLocaleDateString();
      this.selected =
        moment(this.fromDate).format("DD/MM/YYYY") +
        "-" +
        moment(this.toDate).format("DD/MM/YYYY");
      this.filter.startdate = moment
        .utc(this.fromDate.toLocaleString())
        .startOf("days")
        .unix();
      this.filter.enddate = moment
        .utc(this.toDate.toLocaleString())
        .endOf("days")
        .unix();
      // this.dateRangeSelected.emit({ fromDate: this.fromDate, toDate: this.toDate });

      this.fromDate = null;
      this.toDate = null;
      this.fromNGDate = null;
      this.toNGDate = null;
    } else {
      this.fromNGDate = date;
      this.fromDate = new Date(date.year, date.month - 1, date.day);
      this.selected = "";
      this.filter.startdate = 0;
      this.filter.enddate = 0;
    }
  }

  addLang() {
    const language = this.form.language as FormArray;
    let lang = this.makePrice();
    language.push(lang);
  }

  removeLang(i) {
    const language = this.form.language as FormArray;
    language.removeAt(i);
  }

  openModal(content: any) {
    // this.apiService.successmsg()
    this.submitted = false;
    this.formData = this.makeForm({ language: [{}] });
    let a = this.modalService.open(content, {
      centered: true,
      scrollable: true,
      size: "lg",
    });
  }

  openModalOrder(orderReport: any) {
    // this.apiService.successmsg()
    this.submitted = false;
    this.formData = this.makeFormOrder({ language: [{}] });
    let a = this.modalService.open(orderReport, {
      centered: true,
      scrollable: true,
      size: "lg",
    });
  }

  openModalTransaction(transactionReport: any) {
    // this.apiService.successmsg()
    this.submitted = false;
    this.formData = this.makeFormTransaction({ language: [{}] });
    let a = this.modalService.open(transactionReport, {
      centered: true,
      scrollable: true,
      size: "lg",
    });
  }

  openModalLink(contentLink) {
    this.submitted = false;
    this.formData2 = this.makeForm2({ language: [{}] });
    let a = this.modalService.open(contentLink, {
      centered: true,
      scrollable: true,
      size: "lg",
    });
  }
  onEdit(data, content) {
    console.log(data);
    this.formData = this.makeForm(data);
    // this.uploadedImage = data.media.url
    this.modalService.open(content, {
      centered: true,
      scrollable: true,
      size: "xl",
    });
  }

  selectedIncident = null;
  selectedKeyword = null;

  makeFormKeyword(d) {
    let data = d ? d : <any>{};
    return this.formBuilder.group({
      id: [data.id],
      name: [data.name],
      incident_type_id: [data.incident_type_id],
    });
  }

  fetchKeyword() {
    this.dataKeyword = [];
    this.eventService.setLoading(true);
    this.apiService
      .getList(`keyword?type_id=${this.selectedIncident.id}`)
      .subscribe({
        next: (res) => {
          console.log(res);
          this.dataKeyword = [...res];
          this.eventService.setLoading(false);
        },
      });
  }

  dataKeyword = [];

  formEditKeyword: FormGroup;
  formNewKeyword: FormGroup;
  editKeyword(data, index) {
    this.formEditKeyword = this.makeFormKeyword(data);
    this.selectedKeyword = data;
  }

  onSubmitFormKeyword(type) {
    if (type == 1) {
      if (this.formEditKeyword.valid) {
        const value = this.formEditKeyword.value;
        this.eventService.setLoading(true);
        this.apiService.editItem("keyword", value.id, value).subscribe({
          next: (res) => {
            this.selectedKeyword = null;
            this.fetchKeyword();
            this.eventService.setLoading(false);
          },
        });
      }
    } else {
      if (this.formNewKeyword.valid) {
        const value = this.formNewKeyword.value;
        this.eventService.setLoading(true);
        this.apiService.addItem("keyword", value).subscribe({
          next: (res) => {
            this.eventService.setLoading(false);
            this.formNewKeyword.reset({
              incident_type_id: this.selectedIncident.id,
            });
            this.fetchKeyword();
          },
        });
      }
    }
  }

  onOpenKeywordModal(content, incident) {
    this.selectedIncident = incident;
    this.fetchKeyword();
    this.formNewKeyword = this.makeFormKeyword({
      incident_type_id: this.selectedIncident.id,
    });
    this.modalService.open(content, {
      centered: true,
      scrollable: true,
      size: "xl",
    });
  }

  defaultPrices = [
    { condition: 1, price: 0, unit: "" },
    { condition: 2, price: 0, unit: "" },
  ];

  onDeleteKeyword(id) {
    if (id) {
      this.eventService.setLoading(true);
      this.apiService.deleteItem("keyword", id).subscribe((res) => {
        Swal.fire(
          this.translateService.instant("FORM.Success"),
          this.translateService.instant("FORM.SuccessMessageDelete"),
          "success"
        ).then((res) => {
          this.fetchKeyword();
        });
        this.eventService.setLoading(false);
      });
    }
  }

  onDelete(data) {
    Swal.fire({
      title: this.translateService.instant("FORM.Warning"),
      text: this.translateService.instant("FORM.WarningMessage"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#34c38f",
      cancelButtonColor: "#ff3d60",
      confirmButtonText: this.translateService.instant("FORM.WarningConfirm"),
      cancelButtonText: this.translateService.instant("FORM.Cancel"),
    }).then((result) => {
      if (result.value) {
        this.apiService.deleteItem(this.tableName1, data).subscribe((res) =>
          Swal.fire(
            this.translateService.instant("FORM.Success"),
            this.translateService.instant("FORM.SuccessMessageDelete"),
            "success"
          ).then((res) => {
            this.fetchData();
          })
        );
      }
    });
  }

  makeForm(d?) {
    let data = d ? d : <any>{};
    return this.formBuilder.group({
      id: [data.id, []],
      agency_name: [data.agency_name, [Validators.required]],
      branch: [data.branch, [Validators.required]],
      // contact_person: [data.contact_person, [Validators.required]],
      // phone: [data.phone, [Validators.required, Validators.pattern(/(84|0[3|5|7|8|9])+([0-9]{8})\b/g)]],
      // address: [data.address, [Validators.required]],
    });
  }

  makeFormOrder(d?: any): FormGroup {
    let data = d ? d : <any>{};

    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1;
    const currentYear = currentDate.getFullYear();

    return this.fb.group({
      month: [data.month || ""],
      year: [data.year || currentYear],
    });
  }

  makeFormTransaction(d?: any): FormGroup {
    let data = d ? d : <any>{};

    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1;
    const currentYear = currentDate.getFullYear();

    return this.fb.group({
      month: [data.month || ""],
      year: [data.year || currentYear],
    });
  }

  onMonthSelected(event: Date) {
    const selectedDate = new Date(event);
    const month = selectedDate.getMonth() + 1;
    const year = selectedDate.getFullYear();

    this.formData.patchValue({
      month: month,
      year: year,
    });
  }

  onDateChange(event: any) {
    const inputDate = new Date(event.value);
    if (!isNaN(inputDate.getTime())) {
      const month = inputDate.getMonth() + 1;
      const year = inputDate.getFullYear();
      this.formData.patchValue({
        month: month,
        year: year,
      });
    }
  }

  makeForm2(d?) {
    let data = d ? d : <any>{};
    return this.formBuilder.group({
      // id: [data.id],
      // imei : [data.imei, [Validators.required]],
      // description: [data.description],
      // price: [data.price || 0, [Validators.required]],
      // model : [data.model, [Validators.required]],
      // image_url: [data.image_url, [Validators.required]],
      device_id: [data.device_id, [Validators.required]],
      bankaccount_id: [data.bankaccount_id, [Validators.required]],
      // type: [data.type, [Validators.required]],
      // currency: [data.currency || 'VND'],
    });
  }

  makePrices(data = []) {
    let arr = new FormArray([]);
    data.forEach((i) => {
      arr.push(this.makePrice(i));
    });
    return arr;
  }

  viewDetails(data: any) {
    this.router.navigate(["/workspaces/detail-workspace", data.id]);
  }

  makePrice(d?) {
    let data = d ? d : <any>{};
    return this.formBuilder.group({
      key: [data.key, [Validators.required]],
      // price: [data.price, [Validators.required, Validators.min(0)]],
      value: [data.value, [Validators.required]],
      // id: [data.id]
    });
  }

  uploadedImage;

  saveData() {
    this.submitted = true;
    if (this.formData.valid) {
      const value = this.formData.value;
      this.eventService.setLoading(true);
      if (value.id) {
        this.apiService.pacth(this.tableName1, value.id, value).subscribe({
          next: (res) => {
            this.submitted = false;
            this.formData.reset();
            this.fetchData();
            this.modalService.dismissAll();
            this.apiService.showToast(
              this.translateService.instant("FORM.Success"),
              this.translateService.instant("FORM.SuccessMessage"),
              "success"
            );
            this.eventService.setLoading(false);
          },
          error: (e) => {
            this.apiService.showToast(
              this.translateService.instant("FORM.Error"),
              this.translateService.instant("FORM.ErrorMessage"),
              "error"
            );
            this.eventService.setLoading(false);
          },
        });
      } else {
        this.apiService.addItem(this.tableName1, value).subscribe({
          next: (res) => {
            this.fetchData();
            const Toast = Swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 2000,
              timerProgressBar: true,
            });
            Toast.fire({
              icon: "success",
              title: this.translateService.instant("FORM.Success"),
            });

            this.eventService.setLoading(false);
            this.modalService.dismissAll();
          },
          error: (e) => {
            const Toast = Swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 2000,
              timerProgressBar: true,
            });
            Toast.fire({
              icon: "error",
              title: this.translateService.instant("FORM.ErrorMessageAdd"),
            });
            this.eventService.setLoading(false);
            // this.apiService.showToast(this.translateService.instant('FORM.Error'), this.translateService.instant('FORM.userNotExist'), 'error')
            // this.eventService.setLoading(false)
          },
        });
      }
    } else {
      console.log("invalid", this.formData);
      Object.values(this.formData.controls).forEach((control) => {
        if (control.status == "INVALID") {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }

  // saveDataOrder() {
  //   this.submitted = true;
  //   if (this.formData.valid) {
  //     console.log(this.formData.value);
  //     let value = this.formData.value;
  //     this.eventService.setLoading(true);

  //     if (!value.month) value.year = "";

  //     const queryString = `month=${value.month}&year=${value.year}&agency_id=${this.filter.agency_id}`;
  //     const headers = new HttpHeaders({
  //       "Content-Type":
  //         "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //       Accept:
  //         "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //     });

  //     const url = `reports/export-orders?${queryString}`;

  //     this.http.get(url, { headers, responseType: "blob" }).subscribe({
  //       next: (res: Blob) => {
  //         this.eventService.setLoading(false);
  //         const now = new Date();
  //         const formattedDate = `${now.getFullYear()}-${String(
  //           now.getMonth() + 1
  //         ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;

  //         const fileName = `bao-cao-don-hang_${formattedDate}.xlsx`;

  //         saveAs(res, fileName);
  //         this.modalService.dismissAll();

  //       },
  //       error: (e) => {
  //         if (e) {
  //           this.apiService.showToastMobile(
  //             "error",
  //             this.translateService.instant(e)
  //           );
  //         } else {
  //           this.apiService.showToastMobile(
  //             "error",
  //             this.translateService.instant("Xuất file lỗi")
  //           );
  //         }
  //         this.eventService.setLoading(false);
  //       },
  //     });
  //   } else {
  //     console.log("invalid", this.formData);
  //     Object.values(this.formData.controls).forEach((control) => {
  //       if (control.status == "INVALID") {
  //         control.markAsDirty();
  //         control.updateValueAndValidity({ onlySelf: true });
  //       }
  //     });
  //   }
  // }
  // saveDataOrderListShop() {
  //   this.submitted = true;
  //   if (this.formData.valid) {
  //     console.log(this.formData.value);
  //     let value = this.formData.value;
  //     this.eventService.setLoading(true);

  //     if (!value.month) value.year = "";

  //     const queryString = `month=${value.month}&year=${value.year}&agency_id=${this.filter.agency_id}`;
  //     const headers = new HttpHeaders({
  //       "Content-Type":
  //         "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //       Accept:
  //         "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //     });

  //     const url = `reports/bass-noti?${queryString}`;

  //     this.http.get(url, { headers, responseType: "blob" }).subscribe({
  //       next: (res: Blob) => {
  //         this.eventService.setLoading(false);
  //         const now = new Date();
  //         const formattedDate = `${now.getFullYear()}-${String(
  //           now.getMonth() + 1
  //         ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;

  //         const fileName = `bao-cao-don-hang_${formattedDate}.xlsx`;

  //         saveAs(res, fileName);
  //         this.modalService.dismissAll();

  //       },
  //       error: (e) => {
  //         if (e) {
  //           this.apiService.showToastMobile(
  //             "error",
  //             this.translateService.instant(e)
  //           );
  //         } else {
  //           this.apiService.showToastMobile(
  //             "error",
  //             this.translateService.instant("Xuất file lỗi")
  //           );
  //         }
  //         this.eventService.setLoading(false);
  //       },
  //     });
  //   } else {
  //     console.log("invalid", this.formData);
  //     Object.values(this.formData.controls).forEach((control) => {
  //       if (control.status == "INVALID") {
  //         control.markAsDirty();
  //         control.updateValueAndValidity({ onlySelf: true });
  //       }
  //     });
  //   }
  // }
  // saveDataOrderRenewSP() {
  //   this.submitted = true;
  //   if (this.formData.valid) {
  //     console.log(this.formData.value);
  //     let value = this.formData.value;
  //     this.eventService.setLoading(true);

  //     if (!value.month) value.year = "";

  //     const queryString = `month=${value.month}&year=${value.year}&agency_id=${this.filter.agency_id}`;
  //     const headers = new HttpHeaders({
  //       "Content-Type":
  //         "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //       Accept:
  //         "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //     });

  //     const url = `reports/order-renew?${queryString}`;

  //     this.http.get(url, { headers, responseType: "blob" }).subscribe({
  //       next: (res: Blob) => {
  //         this.eventService.setLoading(false);
  //         const now = new Date();
  //         const formattedDate = `${now.getFullYear()}-${String(
  //           now.getMonth() + 1
  //         ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;

  //         const fileName = `bao-cao-gia-han-goi-dich-vu_${formattedDate}.xlsx`;

  //         saveAs(res, fileName);
  //         this.modalService.dismissAll();

  //       },
  //       error: (e) => {
  //         if (e) {
  //           this.apiService.showToastMobile(
  //             "error",
  //             this.translateService.instant(e)
  //           );
  //         } else {
  //           this.apiService.showToastMobile(
  //             "error",
  //             this.translateService.instant("Xuất file lỗi")
  //           );
  //         }
  //         this.eventService.setLoading(false);
  //       },
  //     });
  //   } else {
  //     console.log("invalid", this.formData);
  //     Object.values(this.formData.controls).forEach((control) => {
  //       if (control.status == "INVALID") {
  //         control.markAsDirty();
  //         control.updateValueAndValidity({ onlySelf: true });
  //       }
  //     });
  //   }
  // }
  // saveDataOrderServicepackage() {
  //   this.submitted = true;
  //   if (this.formData.valid) {
  //     console.log(this.formData.value);
  //     let value = this.formData.value;
  //     this.eventService.setLoading(true);

  //     if (!value.month) value.year = "";

  //     const queryString = `month=${value.month}&year=${value.year}&agency_id=${this.filter.agency_id}`;
  //     const headers = new HttpHeaders({
  //       "Content-Type":
  //         "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //       Accept:
  //         "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //     });

  //     const url = `reports/package-sub?${queryString}`;

  //     this.http.get(url, { headers, responseType: "blob" }).subscribe({
  //       next: (res: Blob) => {
  //         this.eventService.setLoading(false);
  //         const now = new Date();
  //         const formattedDate = `${now.getFullYear()}-${String(
  //           now.getMonth() + 1
  //         ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;

  //         const fileName = `bao-cao-goi-dich-vu_${formattedDate}.xlsx`;

  //         saveAs(res, fileName);
  //         this.modalService.dismissAll();

  //       },
  //       error: (e) => {
  //         if (e) {
  //           this.apiService.showToastMobile(
  //             "error",
  //             this.translateService.instant(e)
  //           );
  //         } else {
  //           this.apiService.showToastMobile(
  //             "error",
  //             this.translateService.instant("Xuất file lỗi")
  //           );
  //         }
  //         this.eventService.setLoading(false);
  //       },
  //     });
  //   } else {
  //     console.log("invalid", this.formData);
  //     Object.values(this.formData.controls).forEach((control) => {
  //       if (control.status == "INVALID") {
  //         control.markAsDirty();
  //         control.updateValueAndValidity({ onlySelf: true });
  //       }
  //     });
  //   }
  // }
  // saveDataTransaction() {
  //   this.submitted = true;
  //   if (this.formData.valid) {
  //     console.log(this.formData.value);
  //     const value = this.formData.value;
  //     this.eventService.setLoading(true);

  //     if (!value.month) value.year = "";

  //     const queryString = `month=${value.month}&year=${value.year}&agency_id=${this.filter.agency_id}`;
  //     const headers = new HttpHeaders({
  //       "Content-Type":
  //         "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //       Accept:
  //         "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //     });

  //     const url = `dashboard/mb/export-workspace?${queryString}`;

  //     this.http.get(url, { headers, responseType: "blob" }).subscribe({
  //       next: (res: Blob) => {
  //         this.eventService.setLoading(false);
  //         const now = new Date();
  //         const formattedDate = `${now.getFullYear()}-${String(
  //           now.getMonth() + 1
  //         ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;

  //         const fileName = `bao-cao-giao-dich-cua-hang_${formattedDate}.xlsx`;

  //         saveAs(res, fileName);
  //         this.modalService.dismissAll();

  //       },
  //       error: (e) => {
  //         if (e) {
  //           this.apiService.showToastMobile(
  //             "error",
  //             this.translateService.instant(e)
  //           );
  //         } else {
  //           this.apiService.showToastMobile(
  //             "error",
  //             this.translateService.instant("Xuất file lỗi")
  //           );
  //         }
  //         this.eventService.setLoading(false);
  //       },
  //     });
  //   } else {
  //     console.log("invalid", this.formData);
  //     Object.values(this.formData.controls).forEach((control) => {
  //       if (control.status == "INVALID") {
  //         control.markAsDirty();
  //         control.updateValueAndValidity({ onlySelf: true });
  //       }
  //     });
  //   }
  // }
  saveDataOrder() {
    this.submitted = true;
  
    if (this.formData.valid) {
      const value = this.formData.value;
  
      // Kiểm tra bắt buộc có tháng và năm
      if (!value.month || !value.year) {
        this.apiService.showToastMobile(
          "warning",
          this.translateService.instant("Vui lòng chọn đầy đủ tháng và năm")
        );
        return;
      }
  
      this.eventService.setLoading(true);
  
      const queryString = `month=${value.month}&year=${value.year}&agency_id=${this.filter.agency_id}`;
      const headers = new HttpHeaders({
        "Content-Type":
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        Accept:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
  
      const url = `reports/export-orders?${queryString}`;
  
      this.http.get(url, { headers, responseType: "blob" }).subscribe({
        next: (res: Blob) => {
          this.eventService.setLoading(false);
          const now = new Date();
          const formattedDate = `${now.getFullYear()}-${String(
            now.getMonth() + 1
          ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
          const fileName = `bao-cao-don-hang_${formattedDate}.xlsx`;
          saveAs(res, fileName);
          this.modalService.dismissAll();
        },
        error: (e) => {
          this.apiService.showToastMobile(
            "error",
            this.translateService.instant(e || "Xuất file lỗi")
          );
          this.eventService.setLoading(false);
        },
      });
    } else {
      Object.values(this.formData.controls).forEach((control) => {
        if (control.status === "INVALID") {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }
  
  saveDataOrderListShop() {
    this.submitted = true;
  
    if (this.formData.valid) {
      const value = this.formData.value;
  
      if (!value.month || !value.year) {
        this.apiService.showToastMobile(
          "warning",
          this.translateService.instant("Vui lòng chọn đầy đủ tháng và năm")
        );
        return;
      }
  
      this.eventService.setLoading(true);
  
      const queryString = `month=${value.month}&year=${value.year}&agency_id=${this.filter.agency_id}`;
      const headers = new HttpHeaders({
        "Content-Type":
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        Accept:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
  
      const url = `reports/bass-noti?${queryString}`;
  
      this.http.get(url, { headers, responseType: "blob" }).subscribe({
        next: (res: Blob) => {
          this.eventService.setLoading(false);
          const now = new Date();
          const formattedDate = `${now.getFullYear()}-${String(
            now.getMonth() + 1
          ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
          const fileName = `bao-cao-don-hang_${formattedDate}.xlsx`;
          saveAs(res, fileName);
          this.modalService.dismissAll();
        },
        error: (e) => {
          this.apiService.showToastMobile(
            "error",
            this.translateService.instant(e || "Xuất file lỗi")
          );
          this.eventService.setLoading(false);
        },
      });
    } else {
      Object.values(this.formData.controls).forEach((control) => {
        if (control.status === "INVALID") {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }
  
  saveDataOrderRenewSP() {
    this.submitted = true;
  
    if (this.formData.valid) {
      const value = this.formData.value;
  
      if (!value.month || !value.year) {
        this.apiService.showToastMobile(
          "warning",
          this.translateService.instant("Vui lòng chọn đầy đủ tháng và năm")
        );
        return;
      }
  
      this.eventService.setLoading(true);
  
      const queryString = `month=${value.month}&year=${value.year}&agency_id=${this.filter.agency_id}`;
      const headers = new HttpHeaders({
        "Content-Type":
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        Accept:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
  
      const url = `reports/order-renew?${queryString}`;
  
      this.http.get(url, { headers, responseType: "blob" }).subscribe({
        next: (res: Blob) => {
          this.eventService.setLoading(false);
          const now = new Date();
          const formattedDate = `${now.getFullYear()}-${String(
            now.getMonth() + 1
          ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
          const fileName = `bao-cao-gia-han-goi-dich-vu_${formattedDate}.xlsx`;
          saveAs(res, fileName);
          this.modalService.dismissAll();
        },
        error: (e) => {
          this.apiService.showToastMobile(
            "error",
            this.translateService.instant(e || "Xuất file lỗi")
          );
          this.eventService.setLoading(false);
        },
      });
    } else {
      Object.values(this.formData.controls).forEach((control) => {
        if (control.status === "INVALID") {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }
  
  saveDataOrderServicepackage() {
    this.submitted = true;
  
    if (this.formData.valid) {
      const value = this.formData.value;
  
      if (!value.month || !value.year) {
        this.apiService.showToastMobile(
          "warning",
          this.translateService.instant("Vui lòng chọn đầy đủ tháng và năm")
        );
        return;
      }
  
      this.eventService.setLoading(true);
  
      const queryString = `month=${value.month}&year=${value.year}&agency_id=${this.filter.agency_id}`;
      const headers = new HttpHeaders({
        "Content-Type":
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        Accept:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
  
      const url = `reports/package-sub?${queryString}`;
  
      this.http.get(url, { headers, responseType: "blob" }).subscribe({
        next: (res: Blob) => {
          this.eventService.setLoading(false);
          const now = new Date();
          const formattedDate = `${now.getFullYear()}-${String(
            now.getMonth() + 1
          ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
          const fileName = `bao-cao-goi-dich-vu_${formattedDate}.xlsx`;
          saveAs(res, fileName);
          this.modalService.dismissAll();
        },
        error: (e) => {
          this.apiService.showToastMobile(
            "error",
            this.translateService.instant(e || "Xuất file lỗi")
          );
          this.eventService.setLoading(false);
        },
      });
    } else {
      Object.values(this.formData.controls).forEach((control) => {
        if (control.status === "INVALID") {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }
  
  saveDataTransaction() {
    this.submitted = true;
  
    if (this.formData.valid) {
      const value = this.formData.value;
  
      if (!value.month || !value.year) {
        this.apiService.showToastMobile(
          "warning",
          this.translateService.instant("Vui lòng chọn đầy đủ tháng và năm")
        );
        return;
      }
  
      this.eventService.setLoading(true);
  
      const queryString = `month=${value.month}&year=${value.year}&agency_id=${this.filter.agency_id}`;
      const headers = new HttpHeaders({
        "Content-Type":
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        Accept:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
  
      const url = `dashboard/mb/export-workspace?${queryString}`;
  
      this.http.get(url, { headers, responseType: "blob" }).subscribe({
        next: (res: Blob) => {
          this.eventService.setLoading(false);
          const now = new Date();
          const formattedDate = `${now.getFullYear()}-${String(
            now.getMonth() + 1
          ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
          const fileName = `bao-cao-giao-dich-cua-hang_${formattedDate}.xlsx`;
          saveAs(res, fileName);
          this.modalService.dismissAll();
        },
        error: (e) => {
          this.apiService.showToastMobile(
            "error",
            this.translateService.instant(e || "Xuất file lỗi")
          );
          this.eventService.setLoading(false);
        },
      });
    } else {
      Object.values(this.formData.controls).forEach((control) => {
        if (control.status === "INVALID") {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }
  
  saveData2() {
    this.submitted = true;
    if (this.formData2.valid) {
      const value = this.formData2.value;
      // value['status'] = value['status'] == true ? 0 : 1
      // value['prices'][0]['condition'] = 1
      // value['prices'][1]['condition'] = 2
      // value['price']= value['prices']
      this.eventService.setLoading(true);
      if (value.id) {
        this.apiService.editItem(this.tableName4, value.id, value).subscribe({
          next: (res) => {
            this.submitted = false;
            this.formData2.reset();
            // this.fetchData2()
            // this.fetchData3()
            this.modalService.dismissAll();
            this.apiService.showToast(
              this.translateService.instant("FORM.Success"),
              this.translateService.instant("FORM.SuccessMessage"),
              "success"
            );
            this.eventService.setLoading(false);
          },
          error: (e) => {
            this.apiService.showToast(
              this.translateService.instant("FORM.Error"),
              this.translateService.instant("FORM.ErrorMessage"),
              "error"
            );
            this.eventService.setLoading(false);
          },
        });
      } else {
        this.apiService.addItem("this.tableName4", value).subscribe({
          next: (res) => {
            // this.fetchData2()
            // this.fetchData3()
            const Toast = Swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 2000,
              timerProgressBar: true,
            });
            Toast.fire({
              icon: "success",
              title: this.translateService.instant("FORM.Success"),
            });

            this.eventService.setLoading(false);
            this.modalService.dismissAll();
          },
          error: (e) => {
            const Toast = Swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 2000,
              timerProgressBar: true,
            });
            Toast.fire({
              icon: "error",
              title: this.translateService.instant("FORM.ErrorMessageAdd"),
            });
            this.eventService.setLoading(false);
            // this.apiService.showToast(this.translateService.instant('FORM.Error'), this.translateService.instant('FORM.userNotExist'), 'error')
            // this.eventService.setLoading(false)
          },
        });
      }
    } else {
      console.log("invalid", this.formData2);
      Object.values(this.formData2.controls).forEach((control) => {
        if (control.status == "INVALID") {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }
  isInside(date: NgbDate) {
    return date.after(this.fromNGDate) && date.before(this.toNGDate);
  }
  isHovered(date: NgbDate) {
    return (
      this.fromNGDate &&
      !this.toNGDate &&
      this.hoveredDate &&
      date.after(this.fromNGDate) &&
      date.before(this.hoveredDate)
    );
  }
  /**
   * @param date date obj
   */
  isRange(date: NgbDate) {
    return (
      date.equals(this.fromNGDate) ||
      date.equals(this.toNGDate) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }
}
